import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=6427fa6d&scoped=true"
import script from "./SectionHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SectionHero.vue?vue&type=style&index=0&id=6427fa6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427fa6d",
  null
  
)

export default component.exports